<template>
    <div>
        <h2>{{ $t("Calculette.titreFormulaire") }}</h2>
        <calculette-resultat :resultat="resultat"></calculette-resultat>
        <button type="submit" @click="onSubmit" name="next" class="btn btn-primary submitandwait">
            {{$t("Calculette.buttons.autreSimulation")}}
        </button>
    </div>
</template>

<script>

import ProgressBarUtils from '@/utils/ProgressBarUtils';
import CalculetteResultat from './sections/SectionResultat.vue';

export default {
  name: 'calculette-etape-2',
  props: ['resultat'],
  mixins: [ProgressBarUtils],
  components: {
    CalculetteResultat,
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$router.push({ name: 'routeCalculetteEtape1' });
    },
  },
  mounted() {
    this.initProgressBar(2, [this.$t('Calculette.progressBar.etape1'), this.$t('Calculette.progressBar.etape2')], 2, this.$t('Calculette.titre'));
  },
};
</script>

<style>

</style>
